export function startDuplicatedLabelControl(
  rootElements: (HTMLElement | null) | (HTMLElement | null)[],
  options?: { labelOrphanedInputs?: boolean }
): MutationObserver | null {
  if (!rootElements) {
    return null
  }

  const elements = Array.isArray(rootElements) ? rootElements : [rootElements]

  // Eliminar label interna de cada compos vuetify
  elements?.forEach((rootElement) => removeVuetifyDuplicatedLabel(rootElement, options))

  // Controlar re-renders que vuelvan a insertar la label interna de los compos vuetify
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        elements?.forEach((rootElement) => removeVuetifyDuplicatedLabel(rootElement, options))
        break
      }
    }
  })

  elements?.forEach((rootElement) => {
    if (rootElement && observer) {
      observer.observe(rootElement, { childList: true, subtree: true })
    }
  })

  return observer
}

export function removeVuetifyDuplicatedLabel(
  rootElement: HTMLElement | null,
  options?: { labelOrphanedInputs?: boolean }
) {
  const internalLabels = rootElement?.querySelectorAll<HTMLElement>('label.v-label')

  internalLabels?.forEach((label) => {
    label.remove()
  })

  // Para campos ocultos: añadir title a los inputs huérfanos tras eliminar sus labels
  if (options?.labelOrphanedInputs) {
    const inputs = rootElement?.querySelectorAll<HTMLInputElement>('input, select, textarea')
    inputs?.forEach((input) => {
      if (!input.hasAttribute('title')) {
        input.setAttribute('title', 'hidden')
      }
    })
  }
}

export function endDuplicatedLabelControl(observer: MutationObserver | null) {
  if (observer) {
    observer.disconnect()
    observer = null
  }
}
